import AutorenewRoundedIcon from "@mui/icons-material/AutorenewRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { Box, Button, Chip, Stack, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { OssDataGridFrame } from "../common/OssDataGridFrame";
import { neutralChipSx, ossChipSx, tableActionButtonSx } from "../common/ossChipStyles";

const statusMeta = {
  PENDING: { label: "대기", tone: "#64748b", bg: "#f1f5f9" },
  PROCESSING: { label: "처리 중", tone: "#0369a1", bg: "#f0f9ff" },
  SUCCESS: { label: "성공", tone: "#14b8a6", bg: "#ecfeff" },
  FAILED: { label: "실패", tone: "#ef4444", bg: "#fef2f2" },
  RETRY: { label: "재시도", tone: "#b45309", bg: "#fff7ed" },
};

const directionLabel = {
  IN: "수신",
  OUT: "송신",
};

export const OssIntegrationEventList = ({ rows = [], loading, onRetry, onResolve }) => (
  <OssDataGridFrame height="calc(100vh - 356px)" sx={{ minHeight: 420 }}>
    <DataGrid
      disableRowSelectionOnClick
      loading={loading}
      rows={rows}
      getRowId={(row) => row.integration_event_id}
      columns={[
      {
        field: "system_code",
        headerName: "시스템",
        flex: 0.55,
        renderCell: ({ row }) => (
          <Stack direction="row" spacing={0.6} alignItems="center">
            <Chip size="small" label={row.system_code} variant="outlined" sx={neutralChipSx} />
            <Typography sx={{ fontSize: 12.5, color: "#64748b" }}>
              {directionLabel[row.direction_code] || row.direction_code}
            </Typography>
          </Stack>
        ),
      },
      { field: "event_type", headerName: "이벤트", flex: 0.9 },
      { field: "external_key", headerName: "외부 키", flex: 0.85 },
      {
        field: "event_status",
        headerName: "상태",
        flex: 0.65,
        renderCell: ({ value }) => {
          const meta = statusMeta[value] || { label: value || "-", tone: "#64748b", bg: "#f8fafc" };
          return <Chip size="small" label={meta.label} variant="outlined" sx={ossChipSx(meta)} />;
        },
      },
      {
        field: "retry_count",
        headerName: "재시도",
        flex: 0.5,
        renderCell: ({ value }) => `${Number(value || 0).toLocaleString()}회`,
      },
      { field: "requested_at", headerName: "요청일시", flex: 0.9 },
      { field: "next_retry_at", headerName: "다음 재처리", flex: 0.9 },
      {
        field: "error_message",
        headerName: "오류",
        flex: 1.2,
        renderCell: ({ value }) => (
          <Typography noWrap sx={{ fontSize: 13, color: value ? "#b91c1c" : "#94a3b8" }}>
            {value || "정상"}
          </Typography>
        ),
      },
      {
        field: "actions",
        headerName: "처리",
        flex: 1,
        sortable: false,
        renderCell: ({ row }) => {
          const disabled = row.event_status === "SUCCESS" || row.event_status === "PROCESSING";
          return (
            <Box sx={{ display: "flex", gap: 0.6 }}>
              <Button
                size="small"
                variant="outlined"
                startIcon={<AutorenewRoundedIcon />}
                disabled={disabled}
                onClick={() => onRetry(row)}
                sx={tableActionButtonSx}
              >
                재처리
              </Button>
              <Button
                size="small"
                variant="contained"
                startIcon={<CheckRoundedIcon />}
                disabled={row.event_status === "SUCCESS"}
                onClick={() => onResolve(row)}
                sx={tableActionButtonSx}
              >
                해결
              </Button>
            </Box>
          );
        },
      },
      ]}
      hideFooter={rows.length <= 10}
    />
  </OssDataGridFrame>
);
